import { lazy } from 'react';

// ----------------------------------------------------------------------

const HrSelfServicesPage = lazy(() => import('../pages/HrSelfServices.page'));
const RequestPreviewPage = lazy(() => import('../pages/RequestPreview.page'));
const LoanRequestPreviewPage = lazy(() => import('../pages/LoanRequestPreview.page'));

// ----------------------------------------------------------------------

const HrSelfServicesRoutes = [
    {
        path: '/human-resources/self-services',
        children: [
            { element: <HrSelfServicesPage />, layout: 'default', isAuthReq: true, index: true },
            { path:'request-preview/:id', element: <RequestPreviewPage />, layout: 'default', isAuthReq: true},
            { path:'loan-request-preview/:id', element: <LoanRequestPreviewPage />, layout: 'default', isAuthReq: true},
        ],
    },
];

export { HrSelfServicesRoutes };
